export const skipToMessage = "J$kaOd";
export const readingPane = "sdAwOd";
export default {skipToMessage,readingPane};